import type { CourierToastTheme } from '@trycourier/courier-react';

const PRIMARY = 'hsl(var(--primary))';
const PRIMARY_FG = 'hsl(var(--primary-foreground))';
const BORDER = 'hsl(var(--border))';
const FOREGROUND = 'hsl(var(--foreground))';
const MUTED_FG = 'hsl(var(--muted-foreground))';
const ACCENT_BG = 'hsl(var(--accent))';
const BACKGROUND = 'hsl(var(--background))';
const HEADING_FONT = 'var(--font-heading, "Bebas Neue", "Helvetica Neue", sans-serif)';
const BODY_FONT = 'var(--font-sans, "Inter", "Helvetica Neue", sans-serif)';

export const courierToastTheme: CourierToastTheme = {
  item: {
    backgroundColor: BACKGROUND,
    hoverBackgroundColor: ACCENT_BG,
    autoDismissBarColor: PRIMARY,
    title: { family: HEADING_FONT, weight: '700', size: '14px', color: FOREGROUND },
    body: { family: BODY_FONT, weight: '400', size: '13px', color: MUTED_FG },
    icon: { color: PRIMARY },
    dismissIcon: { color: MUTED_FG },
    shadow: '0 16px 32px rgba(0,0,0,0.10)',
    border: `1px solid ${BORDER}`,
    borderRadius: '12px',
    actions: {
      backgroundColor: PRIMARY,
      hoverBackgroundColor: 'hsl(var(--primary) / 0.9)',
      activeBackgroundColor: 'hsl(var(--primary) / 0.85)',
      border: 'none',
      borderRadius: '4px',
      font: { family: HEADING_FONT, weight: '700', size: '12px', color: PRIMARY_FG },
    },
  },
};
